/* conversions.js — disparo de la conversión de Google Ads del hero.
 *
 * Acción "Solicitar cotización" (AW-17449135591/eX2sCM_g4eYbEOfbsoBB), la misma
 * que vivía en la landing vieja (Views/Landing/Landing.jsx:gotoCotizar). El tag
 * base ya está en public/index.html (global), así que window.gtag existe en toda
 * la app.
 *
 * Se dispara UNA SOLA VEZ por carga de página (dedupe). El brief (§6) avisa que
 * en la landing vieja la conversión se contaba ~4x; aquí solo se cuenta cuando el
 * usuario realmente cotiza: al ENVIAR su descripción a la IA, o al darle COTIZAR
 * (Continuar) en el modo manual. El guard evita re-conteos por reintentos.
 */
let fired = false;

export function fireQuoteConversion() {
  if (fired) return;
  fired = true;
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17449135591/eX2sCM_g4eYbEOfbsoBB',
      });
    }
  } catch (e) {
    // Nunca romper el flujo del hero por un fallo de gtag.
  }
}
